import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export const ProtectedRoute = ({ children, requireApproved = true, requireAdmin = false }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F8FAFC]">
        <p className="text-slate-500">Loading...</p>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (requireAdmin && !user.is_admin) {
    return <Navigate to="/feed" replace />;
  }

  if (requireApproved && !user.is_approved && !user.is_admin) {
    return <Navigate to="/pending" replace />;
  }

  return children;
};

export const PublicRoute = ({ children }) => {
  const { user } = useAuth();

  if (user) {
    if (user.is_admin) {
      return <Navigate to="/admin" replace />;
    }
    if (user.is_approved) {
      return <Navigate to="/feed" replace />;
    }
    return <Navigate to="/pending" replace />;
  }

  return children;
};
